// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { createClientLogger } from "./logger/logger.js";
export const logger = createClientLogger("ts-http-runtime");
